const TREEPERSONAL = {
  start: {
    label: "USA personal Credit System Specialist",
    details: (
      <ul>
        <li>Master the American credit system to access capital and build wealth</li>
        <li>Progression from beginner to expert specialist</li>
        <li>Leverage the credit system as a tool to build wealth</li>
      </ul>
    ),
    children: ["creditFundamentals", "bankingStrategy", "advancedTechniques", "specialistTactics"],
  },
  
  creditFundamentals: {
    label: "Credit System Fundamentals",
    details: (
      <ul>
        <li><strong>Payment History (35%)</strong> - Always pay on time, most critical factor</li>
        <li><strong>Credit Utilization (30%)</strong> - Keep balances at 0% before applications</li>
        <li><strong>Credit History Length (15%)</strong> - Age of oldest account matters most</li>
        <li><strong>Credit Mix (10%)</strong> - Diverse credit types help advanced profiles</li>
        <li><strong>New Credit Inquiries (10%)</strong> - Strategic timing crucial</li>
      </ul>
    ),
    page: "static_html_content-personal/credit-fundamentals",
    children: ["creditFactors", "avoidTechTradelines", "creditBureaus", "profileStages", "debtManagement", "creditRepairWorkflow"],
  },
  
  creditFactors: {
    label: "5 Credit Factors (FICO Scoring)",
    details: (
      <ul>
        <li>Payment History: Never miss payments, late payments severely damage score</li>
        <li>Utilization: Maximum 10% on individual cards, 0% optimal before applications</li>
        <li>History Length: Keep old accounts open permanently, become authorized user on aged accounts</li>
        <li>Credit Mix: Cards, loans, mortgages - not essential for beginners</li>
        <li>New Inquiries: Multiple inquiries in 14-day window count as one</li>
      </ul>
    ),
    page: "static_html_content-personal/credit-factors.html",
    children: [],
  },
  
  creditBureaus: {
    label: "Credit Bureau System",
    details: (
      <ul>
        <li><strong>Personal Bureaus:</strong> Experian, TransUnion, Equifax</li>
        <li><strong>Business Bureaus:</strong> Equifax Business, Experian Business, D&B, SBFE</li>
        <li>Each bureau may have different scores</li>
        <li>Monitor all three bureaus monthly</li>
      </ul>
    ),
    page: "static_html_content-personal/credit-bureaus.html",
    children: [],
  },
  
  profileStages: {
    label: "Profile Development Stages",
    details: (
      <ul>
        <li><strong>Beginner (0-12 months):</strong> 1-3 accounts, secured cards/authorized user</li>
        <li><strong>Intermediate (1-2 years):</strong> 3-6 accounts, $1K-$10K limits</li>
        <li><strong>Advanced (2+ years):</strong> 6-9+ accounts, $10K+ limits, personal credit</li>
        <li>Focus on payment history establishment in early stages</li>
      </ul>
    ),
    page: "static_html_content-personal/profile-stages.html",
    children: [],
  },
  
  bankingStrategy: {
    label: "Strategic Banking Relationships",
    details: (
      <ul>
        <li>Build relationships 3-6 months before credit applications</li>
        <li>Focus on Tier 1 banks for premium opportunities</li>
        <li>Avoid subprime lenders that damage your profile</li>
        <li>Chase Bank strategy as highest priority</li>
      </ul>
    ),
    page: "static_html_content-personal/banking-strategy",
    children: ["bankingTiers", "relationshipBuilding", "chaseStrategy", "applicationTiming"],
  },
  
  bankingTiers: {
    label: "Banking Tier System (USA)",
    details: (
      <ul>
        <li><strong>Tier 1 - National Premium:</strong> Chase, Bank of America, American Express, Wells Fargo</li>
        <li><strong>Tier 2 - Regional/Credit Unions:</strong> Truist, PNC, Navy Federal, PenFed</li>
        <li><strong>Tier 3 - AVOID Subprime:</strong> Store cards, Capital One products, Credit One, Indigo</li>
        <li>Premium banks offer better limits and terms</li>
      </ul>
    ),
    page: "static_html_content-personal/banking-tiers.html",
    children: [],
    premium: 'true',
  },
  
  relationshipBuilding: {
    label: "Banking Relationship Strategy",
    details: (
      <ul>
        <li>Open checking account 3-6 months before credit application</li>
        <li>Maintain positive trending balances (growing monthly)</li>
        <li>Use account regularly for transactions</li>
        <li>Set up direct deposit when possible</li>
        <li>Build credibility before asking for credit</li>
      </ul>
    ),
    page: "static_html_content-personal/relationship-building.html",
    children: [],
  },
  
  chaseStrategy: {
    label: "Chase Bank Specific Strategy",
    details: (
      <ul>
        <li>Open checking account with bonus offer ($300+)</li>
        <li>Use account consistently for 3-6 months</li>
        <li>Build positive banking relationship first</li>
        <li>Apply for Freedom Flex or Sapphire Preferred as first card</li>
        <li>Request credit increases every 91 days</li>
      </ul>
    ),
    page: "static_html_content-personal/chase-strategy.html",
    children: [],
    premium: 'true',
  },
  
  applicationTiming: {
    label: "Application Timing & Strategy",
    details: (
      <ul>
        <li>Wait 91 days between applications to same bank</li>
        <li>Space applications across different credit bureaus</li>
        <li>Never apply when desperate or in financial stress</li>
        <li>Use soft pull pre-qualification before applying</li>
        <li>Only apply when pre-qualified shows good chances</li>
      </ul>
    ),
    page: "static_html_content-personal/application-timing",
    children: [],
  },
  
  advancedTechniques: {
    label: "Advanced Credit Techniques",
    details: (
      <ul>
        <li>0% interest strategies for capital access</li>
        <li>Credit stacking to achieve $100,000+ available credit</li>
        <li>Portfolio management for optimal utilization</li>
      </ul>
    ),
    page: "static_html_content-personal/advanced-techniques",
    children: ["zeroInterestStrategies", "creditStacking", "paymentTiming", "rewardsOptimization", "limitBuilding"],
  },
  
  zeroInterestStrategies: {
    label: "0% Interest Strategies",
    details: (
      <ul>
        <li>Target 12-21 month 0% promotions</li>
        <li>Strategic card rotation every 12-18 months</li>
        <li>Use 0% money for personal investments</li>
        <li>Pay off before promotional period ends</li>
        <li>Balance transfer mastery techniques</li>
      </ul>
    ),
    page: "static_html_content-personal/zero-interest-strategies",
    children: [],
  },
  
  creditStacking: {
    label: "Credit Stacking Method",
    details: (
      <ul>
        <li>Systematic application across multiple banks</li>
        <li>Spread applications across credit bureaus</li>
        <li>Target $100,000+ in available credit</li>
        <li>Same-day applications to maximize approvals</li>
      </ul>
    ),
    page: "static_html_content-personal/credit-stacking",
    children: [],
  },
  
  specialistTactics: {
    label: "Specialist-Level Tactics",
    details: (
      <ul>
        <li>Advanced application strategies for maximum approvals</li>
        <li>Credit limit optimization techniques</li>
        <li>Risk management and protection strategies</li>
        <li>Common mistakes to avoid at specialist level</li>
      </ul>
    ),
    page: "static_html_content-personal/specialist-tactics",
    children: ["advancedApplications", "limitOptimization", "riskManagement", "commonMistakes"],
    premium: 'true',
  },
  
  advancedApplications: {
    label: "Advanced Application Strategies",
    details: (
      <ul>
        <li>Same-day applications to maximize approvals</li>
        <li>Bank of America: 2 cards with single hard pull</li>
        <li>Chase: Strategic personal card combinations</li>
        <li>American Express: personal combinations</li>
        <li>Credit bureau spreading strategies</li>
      </ul>
    ),
    page: "static_html_content-personal/advanced-applications",
    children: [],
    premium: 'true',
  },
  
  limitOptimization: {
    label: "Credit Limit Optimization",
    details: (
      <ul>
        <li>Request increases every 91 days</li>
        <li>Move credit limits between cards at same bank</li>
        <li>Target minimum $10,000 limits on primary cards</li>
        <li>Soft pull vs hard pull increase requests</li>
      </ul>
    ),
    page: "static_html_content-personal/limit-optimization",
    children: [],
    premium: 'true',
  },
  
  riskManagement: {
    label: "Risk Management & Protection",
    details: (
      <ul>
        <li>Maintain emergency cash reserves</li>
        <li>Never use credit for desperate situations</li>
        <li>Have multiple backup funding sources</li>
        <li>Monitor all accounts for fraudulent activity</li>
      </ul>
    ),
    page: "static_html_content-personal/risk-management",
    children: ["amexPayOverTimeWarning"],
    premium: 'true',
  },
  
  commonMistakes: {
    label: "Common Mistakes to Avoid",
    details: (
      <ul>
        <li><strong>Application Errors:</strong> Applying when balances high, to subprime lenders</li>
        <li><strong>Profile Management:</strong> Closing old accounts, high utilization before applications</li>
        <li><strong>Strategic Errors:</strong> No banking relationship, applying when desperate</li>
      </ul>
    ),
    page: "static_html_content-personal/common-mistakes",
    children: [],
    premium: 'true',
  },
  
  // Premium content nodes
  debtManagement: {
    label: "Debt Management Strategies",
    details: (
      <ul>
        <li>Choose a proven method to reduce credit card debt</li>
        <li>Lower utilization before applying for new credit</li>
        <li>Eliminate interest-heavy balances methodically</li>
      </ul>
    ),
    page: "static_html_content-personal/debt-management.html",
    children: ["avalancheMethod", "snowballMethod", "hardshipPrograms", "debtRepositioning"],
  },
  
  avalancheMethod: {
    label: "Avalanche Payoff Method",
    details: (
      <ul>
        <li>Pay highest interest debt first while making minimums on others</li>
        <li>Reduces total interest paid over time</li>
        <li>Ideal for those focused on efficiency</li>
      </ul>
    ),
    page: "static_html_content-personal/avalanche-method.html",
    children: [],
  },
  
  snowballMethod: {
    label: "Snowball Payoff Method",
    details: (
      <ul>
        <li>Pay smallest balances first to build momentum</li>
        <li>Creates early wins to stay motivated</li>
        <li>Effective for behavior-driven payoff success</li>
      </ul>
    ),
    page: "static_html_content-personal/snowball-method.html",
    children: [],
  },
  
  hardshipPrograms: {
    label: "Hardship & Relief Programs",
    details: (
      <ul>
        <li>Negotiate lower interest or payments with creditors</li>
        <li>Use hardship programs during tight cash flow</li>
        <li>Avoid collections while preserving credit score</li>
      </ul>
    ),
    page: "static_html_content-personal/hardship-programs.html",
    children: [],
    premium: 'true',
  },
  
  creditRepairWorkflow: {
    label: "Credit Repair Workflow",
    details: (
      <ul>
        <li>Clean personal credit before building business credit</li>
        <li>Remove errors and collections using FCRA strategies</li>
        <li>Use consumer protection laws to your advantage</li>
      </ul>
    ),
    page: "static_html_content-personal/credit-repair.html",
    children: ["disputeErrors", "removeCollections", "personalInfoCleanup", "utilizationResetLoan"],
    premium: 'true',
  },
  
  disputeErrors: {
    label: "Disputing Credit Report Errors",
    details: (
      <ul>
        <li>Challenge inaccurate or unverifiable items</li>
        <li>Use online disputes or written requests</li>
        <li>Track all correspondence and timelines</li>
      </ul>
    ),
    page: "static_html_content-personal/dispute-errors.html",
    children: [],
    premium: 'true',
  },
  
  removeCollections: {
    label: "Removing Collections Accounts",
    details: (
      <ul>
        <li>Use pay-to-delete or goodwill letters where possible</li>
        <li>Challenge unvalidated debts via FCRA and FDCPA</li>
        <li>Dispute across all three bureaus</li>
      </ul>
    ),
    page: "static_html_content-personal/remove-collections.html",
    children: [],
    premium: 'true',
  },
  
  personalInfoCleanup: {
    label: "Clean Up Personal Information",
    details: (
      <ul>
        <li>Remove old addresses and name variations</li>
        <li>Prevent linkage to bad accounts or old records</li>
        <li>File direct updates with all three credit bureaus</li>
      </ul>
    ),
    page: "static_html_content-personal/personal-info-cleanup.html",
    children: [],
    premium: 'true',
  },
  
  rewardsOptimization: {
    label: "Rewards & Points Optimization",
    details: (
      <ul>
        <li>Maximize redemptions with travel transfer partners</li>
        <li>Learn cash-back vs points redemption strategy</li>
        <li>Extract maximum value per dollar spent</li>
      </ul>
    ),
    page: "static_html_content-personal/rewards-optimization",
    children: ["transferPartnerHacking", "cashbackVsTravel"],
    premium: 'true',
  },
  
  transferPartnerHacking: {
    label: "Transfer Partner Strategy",
    details: (
      <ul>
        <li>Transfer points to airlines and hotel programs</li>
        <li>Achieve 4–6¢ per point vs 1¢ statement credit</li>
        <li>Use transfer bonuses to multiply value</li>
      </ul>
    ),
    page: "static_html_content-personal/transfer-partners",
    children: [],
    premium: 'true',
  },
  
  cashbackVsTravel: {
    label: "Cash Back vs Travel Strategy",
    details: (
      <ul>
        <li>Decide whether to prioritize simplicity or high value</li>
        <li>Cash back is predictable, travel offers bigger returns</li>
        <li>Pick strategy based on lifestyle and goals</li>
      </ul>
    ),
    page: "static_html_content-personal/cashback-vs-travel",
    children: [],
    premium: 'true',
  },
  
  limitBuilding: {
    label: "Credit Limit Building Tactics",
    details: (
      <ul>
        <li>Build high-limit profiles for better approvals</li>
        <li>Use authorized user accounts and internal transfers</li>
        <li>Request limit increases every 91 days</li>
      </ul>
    ),
    page: "static_html_content-personal/limit-building",
    children: ["AUTradelines", "SoftPullCLI", "ComparableCreditStrategy"],
    premium: 'true',
  },
  
  AUTradelines: {
    label: "Authorized User Tradelines",
    details: (
      <ul>
        <li>Add age and limit by becoming AU on seasoned cards</li>
        <li>Choose tradelines with perfect payment history</li>
        <li>Useful for beginners and credit repair</li>
      </ul>
    ),
    page: "static_html_content-personal/au-tradelines",
    children: [],
    premium: 'true',
  },
  
  SoftPullCLI: {
    label: "Soft Pull Credit Line Increases",
    details: (
      <ul>
        <li>Use Amex, Apple/Goldman, Chase, etc. for SP increases</li>
        <li>Apply every 91 days for optimal results</li>
        <li>Max out limit potential before next credit round</li>
      </ul>
    ),
    page: "static_html_content-personal/soft-pull-cli",
    children: [],
    premium: 'true',
  },
  
  ComparableCreditStrategy: {
    label: "Comparable Credit Strategy",
    details: (
      <ul>
        <li>Build personal accounts that mimic business profiles</li>
        <li>Use to qualify for high-limit personal cards</li>
        <li>Match lender expectations before applying</li>
      </ul>
    ),
    page: "static_html_content-personal/comparable-credit",
    children: [],
    premium: 'true',
  },
  
  // Additional nodes
  debtRepositioning: {
    label: "Debt Repositioning Strategy",
    details: (
      <ul>
        <li>Move balances from high-APR cards to 0% or low-APR cards</li>
        <li>Lower monthly payments and improve credit utilization</li>
        <li>Creates margin for larger credit approvals</li>
      </ul>
    ),
    page: "static_html_content-personal/debt-repositioning.html",
    children: [],
    premium: 'true',
  },
  
  utilizationResetLoan: {
    label: "Reset Utilization with Personal Loan",
    details: (
      <ul>
        <li>Use personal loan to pay off high-utilization credit cards</li>
        <li>Utilization drops instantly — credit score rises</li>
        <li>Apply for funding with a "clean" report</li>
      </ul>
    ),
    page: "static_html_content-personal/reset-utilization-loan.html",
    children: [],
    premium: 'true',
  },
  
  paymentTiming: {
    label: "Payment Timing Hack",
    details: (
      <ul>
        <li>Pay down cards 1 day before statement closing date</li>
        <li>Let statement report $0 balance</li>
        <li>Use card again after close without affecting score</li>
      </ul>
    ),
    page: "static_html_content-personal/payment-timing",
    children: [],
    premium: 'true',
  },
  
  avoidTechTradelines: {
    label: "Avoid Tech Company Tradelines",
    details: (
      <ul>
        <li>Cards from fintechs (e.g., Tomo, Grow) don't count with banks</li>
        <li>They inflate the profile with non-bank relationships</li>
        <li>Can reduce funding approval amounts</li>
      </ul>
    ),
    page: "static_html_content-personal/avoid-tech-tradelines.html",
    children: [],
  },
  
  amexPayOverTimeWarning: {
    label: "Avoid Amex Pay Over Time",
    details: (
      <ul>
        <li>Disables your access to more cards and increases</li>
        <li>Traps you in lower-tier Amex internal status</li>
        <li>Always pay Amex in full to avoid soft lock</li>
      </ul>
    ),
    page: "static_html_content-personal/amex-pay-overtime",
    children: [],
    premium: 'true',
  },

};

export default TREEPERSONAL;
export const ROOT_ID = "start";
